export * from './dist/multiselect.component';



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/angular4-multiselect-dropdown/angular4-multiselect-dropdown.ts